import { type ComponentPropsWithoutRef, memo } from 'react';

import { PaletteIcon, PlusIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

export type CustomColorPickerToggleProps = ComponentPropsWithoutRef<'button'>;

export const CustomColorPickerToggle = memo(({ className, onClick, ...restOfProps }: CustomColorPickerToggleProps) => {
  return (
    <button
      className={cn(
        'relative flex h-6 items-center gap-1 rounded-24 border ads:border-ads-gray-5 border-gray-5 px-1 uppercase ring-0 transition-colors ads:hover:bg-hover-subtle hover:bg-gray-4 ads:data-[selected=true]:border-ads-gray-10 data-[selected=true]:border-gray-10 ads:data-[selected=true]:ring-ads-gray-10 data-[selected=true]:ring-1 data-[selected=true]:ring-gray-10 ads:data-[selected=true]:hover:bg-hover-subtle data-[selected=true]:hover:bg-gray-4',
        className,
      )}
      data-testid="CUSTOM_COLOR_PICKER_BUTTON"
      onClick={onClick}
      {...restOfProps}
    >
      <PaletteIcon size="sm" />
      <PlusIcon size="xs" />
    </button>
  );
});

CustomColorPickerToggle.displayName = 'CustomColorPickerToggle';
